import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "react-apollo";

const QUERY = gql`
  query TasksCompleted($queueId: ID!, $fromTimestamp: Int!, $toTimestamp: Int) {
    tasksCompleted(
      queueId: $queueId
      fromTimestamp: $fromTimestamp
      toTimestamp: $toTimestamp
    )
  }
`;

interface Variables {
  queueId: string;
  fromTimestamp: number;
  toTimestamp?: number;
}

interface Data {
  tasksCompleted: number;
}

export const useTasksCompleted = (options?: QueryHookOptions<Data, Variables>) =>
  useQuery<Data, Variables>(QUERY, options);
